<template>
    <div class="hover-border hover-pointer" @click.self="open_edit_menu">
        <div class="or-admin-product-constructor-table" :style="options.style">
            <or-admin-product-constructor-table-ceil @show-edit="edit_ceil" :options="options" :parent="{}" @edit-inner="edit_inner"/>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import orAdminTextarea from './or-admin-textarea.vue';
export default {
    components: {
        orAdminTextarea,
    },
    props: {
        options: Object,
    },
    data() {
        return {
            parent_options: null,
            parent: null,
            ceil_parent_child: false,
            show_icon: false,
            show_edit: false,
            style_titles: {
                height: 'Высота блока (px)',
                marginLeft: 'Отступ слева (%, px)',
                marginRight: 'Отступ справа (%, px)',
                marginBottom: 'Отступ снизу (%, px)',
            },
            style_options: {
            },
            show_ceil_edit: false,
            ceil_options: null,
            ceil_style_titles: {
                textAlign: 'Выравнивание текста',
                fontSize: 'Размер текста (px)',
                fontWeight: 'Толщина текста',
                color: 'Цвет текста',
                alignItems: 'Выравнивание по горизонтали внутри ячейки',
                justifyContent: 'Выравнивание по вертикали внутри ячейки'
            },
            ceil_style_options: {
                textAlign: [
                    'left',
                    'center',
                    'right'
                ],
                fontWeight: [
                    'normal',
                    'bold'
                ],
                color: [
                    '#FFFFFF',
                    '#EBB932'
                ],
                justifyContent: [
                    'flex-start',
                    'center',
                    'flex-end',
                ],
                alignItems: [
                    'flex-start',
                    'center',
                    'flex-end',
                ],
            }
        }
    },
    computed: { 
        ...mapGetters({getAdmin: 'getAdmin'}),
        text() {
            const div = document.createElement('div');
            this.convertText({text: this.options.text.value, container: div});
            return div.innerHTML;
        },
    },
    methods: {
        ...mapActions({convertText: 'convertText',
            addUnsavedPage: 'addUnsavedPage',
            changeAdmin: 'changeAdmin'}),
        open_edit_menu(e) {
            this.changeAdmin({property: 'edit_menu', value: {show: true, left: e.pageX + 'px', top: e.pageY + 'px', this_ctx: this}})
        },
        delete_item() {
            this.$emit('delete_item');
            this.addUnsavedPage({page: 'products'});
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        move_up() {
            this.$emit('move_up');
            this.addUnsavedPage({page: 'products'});
        },
        move_down() {
            this.$emit('move_down');
            this.addUnsavedPage({page: 'products'});
        },
        add_table_to_ceil(options) {
            options.child = {
                ceils: {
                    columns: [
                        {
                            width: '100px',
                            flex: true,
                        },
                        {
                            width: '100px',
                            flex: true,
                        },
                    ],
                    rows: [
                        {
                            height: '50px',
                            flex: true,
                        },
                        {
                            height: '50px',
                            flex: true,
                        },
                    ],
                },
                columns: [
                    [
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                    ],
                    [
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },{
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        },
                    ],
                ],
                style: {
                    height: 'auto',
                    paddingTop: '0px',
                    width: '100%',
                    height: '100%',
                },
            }
            this.addUnsavedPage({page: 'products'});
        },
        delete_table_from_ceil(options, isParent) {
            options.child = null;
            if (isParent) this.close_ceil_edit();
            this.addUnsavedPage({page: 'products'});
        },
        edit_inner({options}) {
            this.changeAdmin({property: 'type', value: 'table'});
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'show_inner_edit', value: true});
            this.changeAdmin({property: 'show_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            // this.show_edit = false;
            // this.show_ceil_edit = true;
            this.ceil_options = options;
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        edit_ceil({options, parent_options, parent}) {
            this.changeAdmin({property: 'type', value: 'table'});
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: true});
            // this.show_edit = false;
            // this.show_ceil_edit = true;
            this.ceil_options = options;
            this.parent_options = parent_options;
            this.parent = parent;
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
        },
        close_ceil_edit() {
            this.changeAdmin({property: 'type', value: null});
            this.changeAdmin({property: 'edit_this', value: null});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            // this.show_ceil_edit = false;
            this.ceil_options = null;
        },
        open_edit() {
            this.changeAdmin({property: 'type', value: 'table'});
            this.changeAdmin({property: 'edit_this', value: this});
            this.changeAdmin({property: 'show_edit', value: true});
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'edit_menu', value: {show: false, left: 0, top: 0, this_ctx: null}})
            // this.show_ceil_edit = false;
            // this.show_edit = true;
        },
        close_edit() {
            this.changeAdmin({property: 'type', value: null});
            this.changeAdmin({property: 'edit_this', value: null});
            this.changeAdmin({property: 'show_ceil_edit', value: false});
            this.changeAdmin({property: 'show_inner_edit', value: false});
            this.changeAdmin({property: 'show_edit', value: false});
            this.show_edit = false;
        },
        add_column(options) {
            const rows = options.columns[0].length;
            const column = [];
            for (let i = 0; i < rows; i++) {
                column.push(
                        {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        });
            }
            options.columns.push(column);
            options.ceils.columns.push(
                {width: '100px', flex: true
                })
            this.addUnsavedPage({page: 'products'});
        },
        delete_column(index, options) {
            if (options.columns.length === 1) return
            options.columns.splice(index, 1);
            options.ceils.columns.splice(index, 1);
            this.addUnsavedPage({page: 'products'});
        },
        add_row(options) {
            const columns = options.columns.length;
            const row = {
                            text: {
                                title: 'Текст в ячейке',
                                value: '',
                            },
                            child: null,
                            style: {
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 'normal',
                                color: '#ffffff',
                            }
                        };
            for (let i = 0; i < columns; i++) {
                options.columns[i].push(JSON.parse(JSON.stringify(row)));
            }
            options.ceils.rows.push({height: '50px', flex: false})
            this.addUnsavedPage({page: 'products'});
        },
        delete_row(index, options) {
            if (options.columns[0].length === 1) return
            const columns = options.columns.length;
            for (let i = 0; i < columns; i++) {
                options.columns[i].splice(index, 1);
            }
            options.ceils.rows.splice(index, 1);
            this.addUnsavedPage({page: 'products'});
        }
    }
}
</script>

<style scoped>
    .or-admin-product-constructor-table {
        position: relative;
        border-radius: 8px;
        border: #EBB932 1px solid;
        overflow: hidden;
    }
    .edit-icon {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 20px;
        height: 20px;
    }
    .edit {
        position: relative;
        width: 100%;
        min-height: 100px;
        box-sizing: border-box;
        padding: 30px;
        background-color: white;
        color: black;
        border-radius: 0 0 8px 8px;
        font-size: 14px;
        line-height: 16px;
        z-index: 999999;
    }
    .input-container {
        margin-bottom: 20px;
    }
</style>